import React from "react";
import LegalShell, { Section } from "@/pages/LegalShell";
import { Mail, MapPin, Clock } from "lucide-react";

export default function AssistancePage() {
    return (
        <LegalShell
            overline="Assistance"
            title="Une équipe humaine à votre écoute."
            subtitle="Que vous soyez entreprise ou professionnel, nous répondons aux questions administratives, techniques ou opérationnelles sous 24 heures ouvrées."
            cta={{
                title: "Besoin de nous joindre ?",
                text: "Utilisez le formulaire de contact — nous vous rappelons rapidement.",
                to: "/#contact",
                label: "Formulaire de contact",
            }}
        >
            <Section title="Nous contacter" id="contact">
                <div className="grid md:grid-cols-3 gap-4 not-prose">
                    <div className="rounded-lg border border-slate-200 p-4">
                        <Mail size={18} className="text-[#F5A623] mb-2" />
                        <div className="font-semibold text-[#0B192C] text-sm">E-mail</div>
                        <a href="mailto:contact@renforteo.fr" className="text-sm text-slate-600 hover:text-[#F5A623]">
                            contact@renforteo.fr
                        </a>
                    </div>
                    <div className="rounded-lg border border-slate-200 p-4">
                        <MapPin size={18} className="text-[#F5A623] mb-2" />
                        <div className="font-semibold text-[#0B192C] text-sm">Adresse</div>
                        <div className="text-sm text-slate-600">
                            41 rue Jean Moulin<br />69300 Caluire-et-Cuire
                        </div>
                    </div>
                    <div className="rounded-lg border border-slate-200 p-4">
                        <Clock size={18} className="text-[#F5A623] mb-2" />
                        <div className="font-semibold text-[#0B192C] text-sm">Délai de réponse</div>
                        <div className="text-sm text-slate-600">
                            Sous 24 h ouvrées<br />Lun–Ven, 9 h – 18 h
                        </div>
                    </div>
                </div>
            </Section>

            <Section title="Situations d'urgence pendant une mission" id="urgence">
                <p>
                    En cas d'incident sur une mission en cours (retard important, absence,
                    problème de sécurité, litige), utilisez d'abord la <b>messagerie mission</b>
                    présente dans votre espace personnel — le client et le professionnel y sont
                    tous deux notifiés instantanément.
                </p>
                <p>
                    Si la situation ne se résout pas via la messagerie, notre équipe intervient
                    manuellement en médiation via l'e-mail ci-dessus. Pour toute situation mettant
                    en jeu la <b>sécurité des personnes</b>, contactez d'abord les services de
                    secours (17 pour la police, 15 pour le SAMU, 18 pour les pompiers).
                </p>
            </Section>

            <Section title="Signalement d'un profil ou d'un comportement" id="signalement">
                <p>
                    Toute personne inscrite sur Renforteo peut signaler un profil ou un
                    comportement problématique via le bouton « Contacter l'équipe » présent
                    dans les espaces personnels, ou par e-mail à{" "}
                    <a href="mailto:contact@renforteo.fr" className="text-[#F5A623]">
                        contact@renforteo.fr
                    </a>
                    . Chaque signalement est examiné manuellement dans un délai maximum de 72 heures
                    ouvrées. Les cas graves entraînent une suspension immédiate à titre conservatoire
                    du profil concerné, le temps de l'instruction.
                </p>
            </Section>

            <Section title="Rappel réglementaire" id="reglementaire">
                <p>
                    Renforteo est un service de mise en relation. La responsabilité contractuelle
                    du bon déroulement de la mission reste entre le client (donneur d'ordre) et
                    le prestataire auto-entrepreneur / indépendant, conformément au Code de
                    commerce, au Code civil et aux CGV. Notre équipe intervient en médiation mais
                    n'a pas autorité pour trancher un litige civil — les tribunaux compétents
                    restent la voie de recours ultime.
                </p>
            </Section>
        </LegalShell>
    );
}
